<div>
  <div
    class="row w-100 d-flex font-size-primary mx-0"
    *ngIf="customerLoyaltyStatus != 'FAILED'"
  >
    <div>
      <div class="mb-2">
        <span class="mr-2">
          <i class="fas fa-trophy theme-color-header"></i>
        </span>
        {{ 'public.profile.loyaltyPointsCollected' | translate }}
        <strong>
          {{
            customerLoyalty?.balance ?? 0
              | formatPrice
                : selectedStoreLocale
                : selectedStoreCurrency
                : selectedStoreCurrencySymbol
          }}/{{
            loyaltyAmountSpent
              | formatPrice
                : selectedStoreLocale
                : selectedStoreCurrency
                : selectedStoreCurrencySymbol
          }}
        </strong>
      </div>
      <div class="mb-2">
        <app-loyalty-progress-bar 
            [balance]="customerLoyalty?.balance"
            [goal]="loyaltyAmountSpent"
        />
      </div>
      <div class="mb-2">
        {{ 'public.profile.loyaltyPointsCurrent' | translate }}
        <strong>
          {{
            customerLoyalty?.voucherValue
              | formatPrice
                : selectedStoreLocale
                : selectedStoreCurrency
                : selectedStoreCurrencySymbol
          }}
        </strong>
      </div>
      <div>
        {{ 'public.loyalty.voucher' | translate }}:
        <span>{{ customerLoyalty?.voucherCode }}</span>
      </div>
    </div>
  </div>
  <div
    *ngIf="customerLoyaltyStatus == 'FAILED'"
    class="w-100 font-size-primary px-2"
  >
    {{ 'public.loyalty.noPoints' | translate }}
  </div>
</div>
